import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

import { PhotoCamera } from "components/authentificationMode/PhotoCamera";
import { CSS_VARIABLES } from "enums/cssVariables";

type PhotoSelectorProps = {
    onSelect: (image: string) => void;
    onSkip: () => void;
};

const PhotoSelector: React.FC<PhotoSelectorProps> = ({ onSelect, onSkip }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [showCamera, setShowCamera] = useState(false);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const objectUrl = URL.createObjectURL(file);
        onSelect(objectUrl);
    };

    const handleTakePhoto = (dataUri: string) => {
        onSelect(dataUri);
        setShowCamera(false);
    };

    return (
        <>
            <ActionButtons>
                <ActionButton type="button" onClick={() => setShowCamera(true)}>
                    <PhotoCameraIcon />
                    {t("photo.takePhoto")}
                </ActionButton>

                <ActionButton
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                >
                    <PhotoLibraryIcon />
                    {t("photo.chooseImage")}
                </ActionButton>
            </ActionButtons>

            <SkipButtonWrapper>
                <SkipButton onClick={onSkip}>{t("photo.skip")}</SkipButton>
            </SkipButtonWrapper>

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
            />

            {showCamera && (
                <PhotoCamera
                    onTakePhoto={handleTakePhoto}
                    onClose={() => setShowCamera(false)}
                />
            )}
        </>
    );
};

export default PhotoSelector;

const ActionButtons = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    width: 100%;
`;

const ActionButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 20px 12px;
    cursor: pointer;
    border-radius: 12px;
    border: 1px solid var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
    background-color: #fafafa;
    color: var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
`;

const SkipButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
`;

const SkipButton = styled.button`
    padding: 10px 18px;
    border-radius: 12px;
    cursor: pointer;
    background-color: var(${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR});
    border: none;
    color: #fff;
`;
